export enum ScreenEnum {
	launch,
	welcome,
	setSecond,
	hardwareCheck,
	softwareCheck,
	selectMarket,
	pairDevice,
	selectDevice,
	password,
	final,
	exit,
	exitNoCancel,
}
